import React, { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { SelectCard } from '@/design-system'
import { getWizardMaterials } from '../../catalog'
import { StepHint, StepLead } from '../StepCopy'

const Grid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: 16,
  '@media (min-width: 540px)': {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  '@media (min-width: 800px)': {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
})

export interface MaterialPickerProps {
  value?: string | number
  onChange: (id: string | number) => void
}

export function MaterialPicker({ value, onChange }: MaterialPickerProps) {
  const materials = useMemo(() => getWizardMaterials(), [])
  const selected = materials.find((m) => m.id === value)

  return (
    <Box>
      <StepLead>
        Floor and wall surface feel. Preset materials — no manual texture editing needed.
      </StepLead>

      {materials.length === 0 ? (
        <Box
          sx={{
            height: 180,
            borderRadius: 20,
            border: '1.5px dashed var(--ds-border)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography sx={{ fontSize: 13, color: 'var(--ds-ink-subtle)' }}>
            No materials available
          </Typography>
        </Box>
      ) : (
        <Grid>
          {materials.map((m) => (
            <SelectCard
              key={String(m.id)}
              title={m.name}
              imageUrl={m.thumbUrl}
              aspectRatio='1 / 1'
              selected={value === m.id}
              onClick={() => onChange(m.id)}
            />
          ))}
        </Grid>
      )}

      {selected && <StepHint>{selected.name} selected — continue to set prints.</StepHint>}
    </Box>
  )
}
